const EN = {
  "english-key": "EN",
  "turkish-key": "TR",

  //   Buttons
  "close-btn": "Close",
  "ok-btn": "OK",
  "next-btn": "Next",
  "back-btn": "Back",
  "show-recommendations-btn": "Show recommendations",

  //   Main
  "first-line-main": "Would you like to make your drink by yourself?",
  "second-line-main": "Come On!!",
  "third-line-main": "Let's make your drink as you like",
  "get-started-main": "Get started",
  "make-your-cocktail-header": "Make Your Cocktail",
  "recommendations-header": "Recommendations",

  //   Making Modal
  "personal-step-label": "Personal",
  "details-step-label": "Details",
  "review-step-label": "Review",
  "name-of-cocktail-bar": "Name of cocktail bar:",
  "first-name-of-owner": "First name of owner:",
  "last-name-of-owner": "Last name of owner:",
  "phone-number": "Phone number:",
  "email-address": "Email address:",
  category: "Category:",
  "type-of-drink": "Type of drink:",
  "type-of-glass": "Type of glass:",
  ingredients: "Ingredients:",
  "choose-category": "choose category",
  "choose-type": "choose type",
  "choose-ingredients": "choose ingredients",
  "ingredients-not-selected": "**Ingredients not selected",
  "please-enter-name": "Please Enter the name",
  "please-enter-first-name": "Please Enter the first name",
  "please-enter-last-name": "Please Enter the last name",
  "please-enter-number": "Please Enter the number",
  "please-enter-email": "Please Enter the email",
  "please-select-cat": "Please Select category",
  "please-select-type": "Please Select type",
  "please-select-ingredients": "Please Select Ingredients",

  //   Recommendations
  "cock-name": "Cocktail Name: ",
  "cock-tags": "Tags: ",
  "no-similar-cocktails": "No similar cocktails",
};

export default EN;
